import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "suitcase"
const SuitcaseIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M14.25 3C15.078 3 15.75 3.672 15.75 4.5V6H21.002L21.155 6.008C21.911 6.085 22.5 6.723 22.5 7.5V20.25C22.5 21.078 21.828 21.75 21 21.75H3C2.223 21.75 1.585 21.16 1.508 20.403L1.5 20.25V7.5C1.5 6.672 2.17 6 2.998 6H8.25V4.5C8.25 3.672 8.922 3 9.75 3zM21 13.307C20.287 13.896 19.372 14.25 18.375 14.25H14.25V14.625C14.25 15.453 13.578 16.125 12.75 16.125H11.25C10.422 16.125 9.75 15.453 9.75 14.625V14.25H5.625C4.628 14.25 3.713 13.896 3 13.307V20.25H21zM11.25 14.625H12.75V11.625H11.25zM3.75 7.5C3.336 7.5 3 7.836 3 8.25V10.125C3 11.575 4.175 12.75 5.625 12.75H9.75V11.625C9.75 10.797 10.422 10.125 11.25 10.125H12.75C13.578 10.125 14.25 10.797 14.25 11.625V12.75H18.375C19.825 12.75 21 11.575 21 10.125V8.25C21 7.836 20.664 7.5 20.25 7.5zM9.75 6H14.25V4.5H9.75z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SuitcaseIcon
